import * as yup from 'yup'

export const loginSchema = yup.object().shape({
    email: yup.string().email("Email must be a valid email").required("Email is required"),
    password: yup.string().min(6, "Password must be at least 6 characters").matches(/^(?=.*[A-Z])/, "Must contain at least one uppercase character").required("Password is a required field")
})